import { AppointmentAvailabilityDTO, AppointmentWindowListDTO, CompanyWindowListDTO } from '_lib/api/apiTypes.shim';

import type { DropDownFilter, CheckboxFilter } from '_lib/types/filter.types';

export interface FilterContext {
  tradeFilter: DropDownFilter;
  serviceTypeFilter: DropDownFilter;
  windowLabelFilter: DropDownFilter;
  warrantyFilter: CheckboxFilter;
}

export const keyExistsInFilterOptions = (filterKey: number, filter: DropDownFilter) =>
  filter.options.some((dropDownOption) => dropDownOption[0] === filterKey);

/**
 * Selects the filter if the given key exists - mutates 'filter' in place
 */
export const setSelectedKeyIfItExistsInFilterOptions = (filterKey: number, filter: DropDownFilter) => {
  if (keyExistsInFilterOptions(filterKey, filter)) filter.selectedKey = filterKey;
};

export interface CompanyWindowsIdMap {
  [key: string]: CompanyWindowListDTO;
}

export interface AvailableWindow {
  appointmentWindow: AppointmentWindowListDTO;
  companyWindow: CompanyWindowListDTO;
  remainingQuantity?: number;
}

export interface WindowResponses {
  companyWindows: CompanyWindowListDTO[];
  configuredCompanyWindows: CompanyWindowListDTO[];
  appointmentWindows: AppointmentWindowListDTO[];
  appointments: AppointmentAvailabilityDTO[];
  companyWindowsIdMap: CompanyWindowsIdMap;
  availableWindows: AvailableWindow[];
}

export interface BookingState {
  companyId: string | null;
  windowResponses: WindowResponses;
  selectedDate: Date | null;
  isSaving: boolean;
  filterContext: FilterContext | null;
  forceFilterRefresh: boolean;
  errorFetchingWindows: boolean;
  filteredWindows: AvailableWindow[];
  validationErrors: string[] | undefined;
}
